module.exports = __webpack_public_path__ + "static/media/digital_plan.53aaf3ba.png";